import moment from 'moment';

import { LegalEntity } from '@models/account/legal-entity.model';

import { ApiAdapter } from './adapter';
import { EstablishmentAdapter } from './establishment.adapter';

export class LegalEntityAdapter extends ApiAdapter<LegalEntity> {
  private establishmentAdapter = new EstablishmentAdapter();

  get(json): LegalEntity {
    return new LegalEntity({
      id: json['link_id'],
      accountId: json['account_id'],
      validityStartDate: json['validity_start_date'] ? moment.tz(json['validity_start_date'], moment.tz.guess()) : undefined,
      validityEndDate: json['validity_end_date'] ? moment.tz(json['validity_end_date'], moment.tz.guess()) : undefined,
      legalEntityCode: json['legal_entity_code'],
      code: json['legal_entity_code'],
      name: json['legal_entity']['full_legal_name'] || json['legal_entity']['nomen_long'],
      zipCode: json['legal_entity']['zip_code'],
      establishments: this.establishmentAdapter.list(json['legal_entity']['establishments']).map((establishment) => {
        establishment.legalEntity = new LegalEntity({
          id: json['id'],
          code: json['legal_entity']['code'],
          legalEntityCode: json['legal_entity']['legal_entity_code'],
        });
        return establishment;
      }),
    });
  }
}
